module.exports = __webpack_public_path__ + "media/AUDIO 22.d1bb6c4a.mp3";